import React, { useState } from 'react';
import AutTable from '../../blocks/aut-grid-table/index';
import ETInspectionItemForm from '../../forms/et/etInspectionItemForm';
import ETInspectionItemEditForm from '../../forms/et/etInspectionItemEditForm';

import * as data from '../../../utils/data';
import * as models from '../../../utils/models';

interface Props {
	items: models.ETIReportItem[];
	onChangeItems: (items: models.ETIReportItem[]) => void;
	photoNumbers: { label: number | string; value: number | string; }[];
}

const ETInspectionItems: React.FC<Props> = ({ items, onChangeItems, photoNumbers }) => {
	const [inspectionItemToEdit, setToEditInspectionItem] = useState<models.ETIReportItem | null>(null);

	const onAddItem = (item: models.ETIReportItem) => {
		const updatedItem = { ...item, srNo: items.length + 1 };
		onChangeItems([...items, updatedItem]);
	};

	const onDeleteItem = (itemToDelete: models.ETIReportItem): void => {
		const updatedItems = items.filter((item) => item.srNo !== itemToDelete.srNo);
		onChangeItems(updatedItems);
	};

	const onEditItem = (itemToEdit: models.ETIReportItem) => {
		const updatedItems = items.map((item) => item.srNo === inspectionItemToEdit?.srNo ? itemToEdit : item);
		onChangeItems(updatedItems);

		setToEditInspectionItem(null);
	}

	return ( 
		<>
			{inspectionItemToEdit ? (
				<ETInspectionItemEditForm 
					initialData={inspectionItemToEdit}
					onEdit={onEditItem} 
					photoNumbers={photoNumbers} 
					onCancelEdit={() => setToEditInspectionItem(null)} 
				/>
			) : (
				<ETInspectionItemForm 
					onAdd={onAddItem} 
					photoNumbers={photoNumbers} 
				/>
				)}
			

			<AutTable
				tableColumns={data.getETTestingColumns()}
				data={items}
				onDeleteItem={onDeleteItem}
				onEditItem={(item) => setToEditInspectionItem(item)}
			/>
		</>
	 );
}
 
export default ETInspectionItems;